import {cieloWrap} from 'init';
import {useKalturaWrapper, initKalturaWrapper} from 'adapters/kaltura/entry-point';

const registerDOMContentLoaded = () => document.addEventListener('DOMContentLoaded', cieloWrap);

const init = async () => {
    if (!useKalturaWrapper()) return registerDOMContentLoaded();

    try {
        await initKalturaWrapper();
    } catch (error) {
        console.error(error); // eslint-disable-line no-console
        registerDOMContentLoaded();
    }
};

if (!window.cieloWrap) {
    window.cieloWrap = cieloWrap;
    init();
}



// WEBPACK FOOTER //
// ./scripts/index.js